<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12 d-flex flex-wrap justify-content-between">
            <!-- <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                routerLink="/user/create-user"><i class="fas fa-user-plus">
                </i>Create Users</button> -->
        </div>

        <div class="col-12">

            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3">Language Management</h5>

                <app-loader [show]="showLoader"></app-loader>

                <!-- server search  -->
                <!-- <form class="server-search-table p-3" [formGroup]="emailForm" (submit)="getUserByName()">
                    <div class="form-group">
                        <input type="text" class="form-control" placeholder="Search" formControlName="email">
                        <button type="submit" class="btn-search-table">
                            <i class="fas fa-search"></i>
                        </button>
                    </div>
                </form>

                <app-loader [show]="searching"></app-loader> -->

                <div class="table-responsive py-3" style="padding: 1rem!important" *ngIf="showLoader==false">
                    <table class="table-striped" class="table" id="datatable">
                        <thead>
                            <tr>
                                <th>Language Code</th>
                                <th>Language Name</th>
                                <th>Language Direction</th>
                                <th>Default</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let res of langData">
                                <td class="cursor-pointer">{{res.langCode}}</td>
                                <td class="cursor-pointer">{{res.langName}}</td>
                                <td class="cursor-pointer">{{res.langDirection}}</td>
                                <td class="cursor-pointer">{{res.defaultLang}}</td>
                            </tr>
                        </tbody>

                    </table>

                    <!-- server footer 
                    <div class="d-flex justify-content-between flex-wrap p-3">
                        <div>
                            <b>Showing</b> {{currentIndex * pageLength + 1}} - {{usersSearch.length + currentIndex *
                            pageLength}}
                            <b>of</b>
                            {{totalRecords}}
                        </div>
                        <nav aria-label="Page navigation example">
                            <ul class="pagination pagination-sm flex-wrap">
                                <li class="page-item rounded-0">
                                    <a class="page-link border-0" (click)="getNewData(currentIndex - 1)"
                                        [class.disabled]="currentIndex == 0">Previous</a>
                                </li>
                                <li class="page-item rounded-0" [class.active]="currentIndex == i"
                                    *ngFor="let page of paging;let i=index">
                                    <a class="page-link border-0 " (click)="getNewData(i)">{{i+1}}</a>
                                </li>
                                <li class="page-item rounded-0">
                                    <a class="page-link border-0" (click)="getNewData(currentIndex + 1)"
                                        [class.disabled]="currentIndex == paging.length - 1">Next</a>
                                </li>
                            </ul>
                        </nav>
                    </div> -->

                </div>
            </div>
        </div>


    </div>
</div>